import React, { FC } from 'react'
import styled from 'styled-components/native'

import { ViewGap } from 'ui/components/ViewGap/ViewGap'
import { Typo } from 'ui/theme'
import { setTextSemantic } from 'ui/theme/typographyAttrs/setTextSemantic'

export type InfoListItemProps = {
  title: string
  value?: string | null
  testID?: string
}

export const Summary: FC<{ title: string; data: InfoListItemProps[] }> = ({ data, title }) => {
  const filteredData = data.filter(({ value }) => !!value)

  return (
    <ViewGap gap={5}>
      <Typo.Title3 {...setTextSemantic('p')}>{title}</Typo.Title3>
      <BodyContainer gap={6}>
        {filteredData.map((item) => (
          <SummaryItem key={item.title} {...item} />
        ))}
      </BodyContainer>
    </ViewGap>
  )
}

const SummaryItem: FC<InfoListItemProps> = ({ testID, title, value }) => {
  return (
    <ViewGap gap={1}>
      <Typo.BodyXs>{title}</Typo.BodyXs>
      <Typo.BodyAccent testID={testID}>{value}</Typo.BodyAccent>
    </ViewGap>
  )
}

const BodyContainer = styled(ViewGap)(({ theme }) => ({
  backgroundColor: theme.designSystem.color.background.subtle,
  paddingVertical: theme.designSystem.size.spacing.xxl,
  paddingHorizontal: theme.designSystem.size.spacing.xl,
  borderRadius: theme.designSystem.size.borderRadius.m,
}))
